import request from '@/utils/infrastructure/communication/request';

export async function queryEditActive(id) {
  return request.post(`/webApiConnectionGroup/activate/${id}`, {});
}
